(function () {
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function money(cents) {
    var settings = window.MinimogSettings || {};
    if (typeof window.formatMoney === 'function' && settings.money_format) {
      return String(window.formatMoney(cents, settings.money_format)).replace(/<[^>]*>/g, '').trim();
    }
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }
  function escapeHtml(v) {
    return String(v || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[c];
    });
  }
  function stem(t) {
    return String(t || '').toLowerCase().replace(/[^a-z0-9 ]/g, ' ')
      .split(/\s+/).filter(Boolean).slice(0, 3).join(' ');
  }
  function isBeautyfort(p) {
    var tags = p.tags || [];
    if (typeof tags === 'string') tags = tags.split(/,\s*/);
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toLowerCase() === 'beautyfort') return true;
    }
    return false;
  }
  // Words of a title without sizes ("12ft"), padded so a whole product name can be found inside another title.
  function plainTitle(t) {
    return ' ' + String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').split(' ')
      .filter(function (w) { return w && !/\d/.test(w); }).join(' ') + ' ';
  }
  // A replacement cover or spare part fits one product only.
  function isFittedPart(p) {
    return /\b(replacement|spare)\b|\bpillow ?case\b/i.test(String(p.title || ''));
  }
  function isFragrance(p) {
    if (isBeautyfort(p)) return true;
    var t = String(p.product_type || p.type || '') + ' ' + String(p.title || '');
    return /fragrance|perfume|eau de|parfum|toilette|cologne|\bedp\b|\bedt\b/i.test(t);
  }

  var SURFACES = {
    drawer: {
      boxId: 'kp-drawer-recs',
      listId: 'kp-drawer-recs-list',
      itemSel: '#MinimogCartDrawer .m-cart-item',
      nameSel: '#MinimogCartDrawer .m-cart-item__title',
      max: 4,
      seed: null,
      loading: null,
      revision: 0,
      controller: null
    },
    cart: {
      boxId: 'kp-cart-recs',
      listId: 'kp-cart-recs-list',
      itemSel: '#MinimogCart .m-cart-item',
      nameSel: '#MinimogCart .m-cart-item__title',
      max: 4,
      seed: null,
      loading: null,
      revision: 0,
      controller: null
    }
  };

  function loadRecs(key) {
    var S = SURFACES[key];
    if (!S) return;
    var drawer = document.getElementById('MinimogCartDrawer');
    if (key === 'drawer' && (!drawer || !drawer.classList.contains('m-cart-drawer--active'))) return;
    var box = document.getElementById(S.boxId);
    if (!box) return;
    var seed = box.getAttribute('data-seed');
    if (!seed) return;
    var liveList = document.getElementById(S.listId);
    if (seed === S.seed && liveList && liveList.children.length) return;
    if (S.loading === seed) return;
    var revision = ++S.revision;
    if (S.controller) S.controller.abort();
    S.controller = new AbortController();
    S.loading = seed;
    S.seed = seed;

    var team = box.getAttribute('data-team') || '';
    var seedType = (box.getAttribute('data-seed-type') || '').trim().toLowerCase();
    var singles = (box.getAttribute('data-single-types') || '').split(',')
      .map(function (t) { return t.trim().toLowerCase(); })
      .filter(Boolean);
    var singleOnly = seedType && singles.some(function (s) {
      return seedType.indexOf(s) !== -1 || s.indexOf(seedType) !== -1;
    });

    function getRecs(intent) {
      return fetch(root() + 'recommendations/products.json?product_id=' + encodeURIComponent(seed) + '&limit=8&intent=' + intent, {
        headers: { Accept: 'application/json' },
        signal: S.controller.signal
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return (d && d.products) || []; })
        .catch(function () { return []; });
    }

    function getTeamProducts() {
      return fetch(root() + 'search?type=product&options[unavailable_products]=hide&q=' + encodeURIComponent('tag:"' + team + '"') + '&section_id=kp-team-recs-data', { signal: S.controller.signal })
        .then(function (r) { if (!r.ok) throw new Error('Team products unavailable'); return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var data = doc.querySelector('[data-team-products]');
          return data ? JSON.parse(data.textContent) : [];
        });
    }

    // Live rule sources from kp-cart-recs.liquid: collection URLs with storefront filters or "rec:<intent>",
    // each rendered through sections/kp-cart-recs-data in the shopper's market. Order is priority order.
    var pools = [];
    try { pools = JSON.parse(box.getAttribute('data-pools') || '[]'); } catch (e) { pools = []; }
    if (!Array.isArray(pools)) pools = [];
    var maxPrice = Number(box.getAttribute('data-max-price')) || 0;
    var pooled = !team && pools.length > 0;

    function getPool(pool) {
      var url = String(pool).indexOf('rec:') === 0
        ? root() + 'recommendations/products?product_id=' + encodeURIComponent(seed) + '&limit=10&intent=' + encodeURIComponent(String(pool).slice(4))
        : String(pool);
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=kp-cart-recs-data';
      return fetch(url, { signal: S.controller.signal })
        .then(function (r) { if (!r.ok) throw new Error('Suggestion source unavailable'); return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var data = doc.querySelector('[data-kp-recs-pool]');
          var list = data ? JSON.parse(data.textContent) : [];
          return Array.isArray(list) ? list : [];
        })
        .catch(function () { return []; });
    }

    var products = team ? getTeamProducts().then(function (items) { return [[], items]; })
      : pooled ? Promise.all(pools.map(getPool)).then(function (sets) { return [[], [].concat.apply([], sets)]; })
      : Promise.all([
        getRecs('complementary'),
        singleOnly ? Promise.resolve([]) : getRecs('related')
      ]);
    products.then(function (sets) {
      var items = sets[0].concat(sets[1]);
      var liveBox = document.getElementById(S.boxId);
      var list = document.getElementById(S.listId);
      if (revision !== S.revision || liveBox !== box || !list || liveBox.getAttribute('data-seed') !== seed) return;
      var seedVendor = (liveBox.getAttribute('data-seed-vendor') || '').toLowerCase();
      var dept = (liveBox.getAttribute('data-dept') || '').toLowerCase();
      var seen = {};
      document.querySelectorAll(S.itemSel).forEach(function (el) {
        var id = el.getAttribute('data-product-id');
        if (id) seen[id] = 1;
      });
      var cartStems = [];
      var cartTitles = [];
      document.querySelectorAll(S.nameSel).forEach(function (el) {
        var st = stem(el.textContent);
        if (st) cartStems.push(st);
        var title = plainTitle(el.textContent);
        if (title.trim()) cartTitles.push(title);
      });
      function fits(p) {
        var partTitle = plainTitle(p.title);
        return cartTitles.some(function (t) { return partTitle.indexOf(t) !== -1; });
      }
      // Complementary types for the basket item (kp-cart-recs.liquid), in order: a cover that fits the basket
      // first, then each preferred type; any other type is not an add-on for this item.
      var prefer = [];
      try { prefer = JSON.parse(liveBox.getAttribute('data-prefer-types') || '[]'); } catch (e) { prefer = []; }
      if (!Array.isArray(prefer)) prefer = [];
      prefer = prefer.map(function (t) { return String(t).trim().toLowerCase(); });
      function rank(p) {
        if (isFittedPart(p)) return fits(p) ? -1 : 99;
        var i = prefer.indexOf(String(p.type || p.product_type || '').toLowerCase());
        return i === -1 ? 99 : i;
      }
      if (prefer.length) {
        items = items.map(function (p, i) { return { p: p, i: i }; })
          .sort(function (a, b) { return rank(a.p) - rank(b.p) || a.i - b.i; })
          .map(function (x) { return x.p; });
      }
      var shownStems = {};
      var shown = 0;
      var html = '';
      items.forEach(function (p) {
        if (shown >= S.max || seen[String(p.id)] || !p.available) return;
        if ((Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(/,\s*/)).includes('kp-wallbed-addon')) return;
        var candidateType = String(p.product_type || p.type || '').toLowerCase();
        if (singles.some(function (type) { return candidateType.indexOf(type) !== -1; })) return;
        // Taylors international delivery has resumed; match the published market catalogue.
        var candidateVendor = String(p.vendor || '').trim().toLowerCase();
        if (root() !== '/' && candidateVendor !== 'artisan' && candidateVendor !== 'taylors') return;
        if (team && (String(p.vendor || '').toLowerCase() !== 'taylors' ||
            (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(/,\s*/)).indexOf(team) === -1)) return;
        if (dept === 'fragrance' && !isFragrance(p)) return;
        // A cover or spare part only beside the product it fits; with a type map, only the mapped types.
        if (isFittedPart(p) ? !fits(p) : prefer.length && rank(p) === 99) return;
        var pStem = stem(p.title);
        if (seedVendor !== 'taylors' && cartStems.indexOf(pStem) !== -1) return;
        // One colourway or size per product (two Avora nightstands, two sizes of one perfume); football
        // titles all start with the club, so the team rail keeps its own range.
        if (!team && seedVendor !== 'taylors' && pStem && shownStems[pStem]) return;
        // Add-ons, not alternatives: outside fragrance and football, skip the main item's own product type.
        if (dept !== 'fragrance' && seedVendor !== 'taylors' && (pooled || sets[0].length) && seedType &&
            String(p.type || p.product_type || '').toLowerCase() === seedType) return;
        // Made to order in this market (Artisan per-market stock): never offered as a quick add-on.
        if (p.kp_mto === true) return;
        var allVariants = p.variants || [];
        var v = null;
        for (var vi = 0; vi < allVariants.length; vi++) {
          if (allVariants[vi].available) { v = allVariants[vi]; break; }
        }
        if (!v) return;
        if (pooled && maxPrice) {
          // Preselect the first in-stock option within the cap; skip the product when none is.
          var capped = null;
          for (var ci = 0; ci < allVariants.length; ci++) {
            if (allVariants[ci].available && Number(allVariants[ci].price) <= maxPrice) { capped = allVariants[ci]; break; }
          }
          if (!capped) return;
          v = capped;
        }
        seen[String(p.id)] = 1;
        if (pStem) shownStems[pStem] = 1;
        var img = p.featured_image || '';
        if (img && typeof img === 'object') img = img.src || img.url || '';
        if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=200';
        var imgTag = img ? '<img src="' + escapeHtml(img) + '" alt="" width="64" height="72" loading="lazy" decoding="async">' : '';
        var url = p.url || (p.handle ? (root() + 'products/' + p.handle) : '#');
        var variants = p.variants || [];
        var opts = p.options || [];
        if (opts.length && typeof opts[0] === 'string') opts = opts.map(function (name) { return { name: name }; });
        var optionCount = opts.length;
        var inline = variants.length > 1 && optionCount === 1;
        var toPage = variants.length > 1 && optionCount > 1;
        var lowestPrice = Math.min.apply(null, variants.filter(function (vr) { return vr.available; }).map(function (vr) { return vr.price; }));
        var priceLabel = toPage ? 'From ' + money(lowestPrice) : money(v.price);
        var selectHtml = '';
        if (inline) {
          selectHtml = '<select class="kp-drec__variant" aria-label="' + escapeHtml((opts[0] && opts[0].name) || 'Option') + '">';
          variants.forEach(function (vr) {
            selectHtml += '<option value="' + vr.id + '" data-price="' + Number(vr.price) + '"' + (vr.available ? '' : ' disabled') + (vr.id === v.id ? ' selected' : '') + '>' +
              escapeHtml(vr.title) + (vr.available ? '' : ' — sold out') + '</option>';
          });
          selectHtml += '</select>';
        }
        var action = toPage
          ? '<a class="kp-drec__add" href="' + escapeHtml(url) + '">Choose</a>'
          : '<button type="button" class="kp-drec__add" data-rec-add="' + v.id + '">Add</button>';
        html += '<div class="kp-drec' + (inline ? ' kp-drec--opts' : '') + '" role="listitem">' +
          '<a class="kp-drec__img" href="' + escapeHtml(url) + '">' + imgTag + '</a>' +
          '<div class="kp-drec__meta"><a class="kp-drec__title" href="' + escapeHtml(url) + '">' + escapeHtml(p.title) + '</a>' +
          '<span class="kp-drec__price">' + priceLabel + '</span>' +
          '<div class="kp-drec__pick">' + selectHtml + action + '</div><p class="kp-drec__error" role="status" aria-live="polite"></p></div></div>';
        shown++;
      });
      S.loading = null;
      list.innerHTML = html;
      liveBox.hidden = !shown;
      list.scrollLeft = 0;
      updateAllNav();
    }).catch(function () {
      if (revision === S.revision) S.loading = null;
    });
  }

  // Descendant overflow can inflate scrollWidth beyond the actual cards.
  function railBounds(list) {
    var width = list.clientWidth;
    var starts = [], end = 0;
    if (width) {
      var origin = list.getBoundingClientRect().left + list.clientLeft;
      Array.prototype.forEach.call(list.children, function (card) {
        if (!card.classList.contains('kp-drec') || card.hidden) return;
        var rect = card.getBoundingClientRect();
        if (!rect.width) return;
        starts.push(Math.max(0, rect.left - origin + list.scrollLeft));
        end = Math.max(end, rect.right - origin + list.scrollLeft);
      });
    }
    return { width: width, starts: starts, max: Math.max(0, end - width) };
  }

  // Arrows and swipe scrolling share the bounds of the rendered cards.
  function updateNav(list) {
    if (!list || typeof list.closest !== 'function') return;
    var nav = list.closest('.kp-drecs, .kp-cart-recs');
    nav = nav && nav.querySelector('.kp-drecs__nav');
    if (!nav) return;
    var bounds = railBounds(list);
    // Browsers may round fractional endpoints; rewriting that offset cancels smooth scrolling.
    if (bounds.width && (list.scrollLeft < -2 || list.scrollLeft > bounds.max + 2)) {
      list.scrollLeft = Math.max(0, Math.min(list.scrollLeft, bounds.max));
    }
    nav.hidden = !bounds.width || bounds.max <= 2;
    var arrows = nav.querySelectorAll('[data-recs-scroll]');
    if (arrows[0]) arrows[0].disabled = nav.hidden || list.scrollLeft <= 2;
    if (arrows[1]) arrows[1].disabled = nav.hidden || list.scrollLeft >= bounds.max - 2;
  }

  var observedRails = [];
  var railObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(queueNav) : null;
  function updateAllNav() {
    var observed = [];
    document.querySelectorAll('.kp-drecs__list').forEach(function (list) {
      updateNav(list);
      observed.push(list);
      Array.prototype.forEach.call(list.children, function (card) { observed.push(card); });
    });
    if (railObserver) {
      observedRails.forEach(function (element) {
        if (observed.indexOf(element) === -1) railObserver.unobserve(element);
      });
      observed.forEach(function (element) {
        if (observedRails.indexOf(element) === -1) railObserver.observe(element);
      });
      observedRails = observed;
    }
  }

  function refreshAll() {
    Object.keys(SURFACES).forEach(function (key) {
      var surface = SURFACES[key];
      surface.revision++;
      if (surface.controller) surface.controller.abort();
      surface.seed = surface.loading = null;
    });
    loadRecs('drawer');
    loadRecs('cart');
    updateAllNav();
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.kp-drec__variant')) return;
    var option = e.target.selectedOptions[0];
    var card = e.target.closest('.kp-drec');
    if (card && option) card.querySelector('.kp-drec__price').textContent = money(Number(option.dataset.price));
  });

  function scrollRail(arrow) {
    var list = document.getElementById(arrow.getAttribute('aria-controls'));
    if (!list) return;
    var bounds = railBounds(list);
    if (!bounds.width) return;
    var current = Math.max(0, Math.min(list.scrollLeft, bounds.max));
    var forward = Number(arrow.getAttribute('data-recs-scroll')) > 0;
    var target = forward ? bounds.max : 0;
    var starts = forward ? bounds.starts : bounds.starts.slice().reverse();
    for (var i = 0; i < starts.length; i++) {
      if (forward ? starts[i] > current + 2 : starts[i] < current - 2) {
        target = Math.max(0, Math.min(starts[i], bounds.max));
        break;
      }
    }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    list.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
    updateNav(list);
  }

  var navFrame = 0;
  function queueNav(e) {
    // Capture-phase scroll sees every scroller on the page; only the rails matter.
    if (e && e.type === 'scroll' && !(e.target && e.target.classList && e.target.classList.contains('kp-drecs__list'))) return;
    if (navFrame || typeof requestAnimationFrame !== 'function') return;
    navFrame = requestAnimationFrame(function () { navFrame = 0; updateAllNav(); });
  }
  document.addEventListener('scroll', queueNav, { capture: true, passive: true });
  if (typeof window.addEventListener === 'function') window.addEventListener('resize', queueNav, { passive: true });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rec-add]');
    if (!btn) {
      var arrow = e.target.closest('[data-recs-scroll]');
      if (arrow) scrollRail(arrow);
      return;
    }
    if (btn.disabled) return;
    e.preventDefault();
    var card = btn.closest('.kp-drec');
    var sel = card && card.querySelector('.kp-drec__variant');
    var id = sel ? sel.value : btn.getAttribute('data-rec-add');
    if (!id) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var error = card.querySelector('.kp-drec__error');
    error.textContent = '';
    if (sel) sel.disabled = true;
    var kpAdd = { source: window.KPTheme?.source(btn), variant_id: id, quantity: 1 };
    window.KPTheme?.track('cart_add_attempt', kpAdd);
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw res.d;
        window.KPTheme?.added(res.d, kpAdd);
        btn.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      })
      .catch(function (failure) {
        window.KPTheme?.track('cart_add_failure', kpAdd);
        btn.disabled = false;
        btn.textContent = 'Add';
        if (sel) sel.disabled = false;
        error.textContent = typeof failure.description === 'string' ? failure.description : 'Could not add this item. Please try again.';
      });
  });

  // <kp-wallbed-cart-extras> (GB, non-empty cart) can first appear in a cart re-render; the layout
  // loads its script only when the page was rendered with a non-empty GB cart or on a GB wall-bed PDP.
  var wallbedExtrasRequested = false;
  function ensureWallbedExtras() {
    var src = window.MinimogThemeScripts && window.MinimogThemeScripts.wallbedCartExtras;
    if (!src || wallbedExtrasRequested) return;
    if (window.customElements && window.customElements.get('kp-wallbed-cart-extras')) return;
    if (!document.querySelector('kp-wallbed-cart-extras')) return;
    wallbedExtrasRequested = true;
    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onerror = function () { wallbedExtrasRequested = false; script.remove(); };
    document.head.appendChild(script);
  }
  function onCartRendered() {
    ensureWallbedExtras();
    refreshAll();
  }
  document.addEventListener('cart:updated', onCartRendered);
  document.addEventListener('cart:rendered', onCartRendered);

  if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, function () {
      loadRecs('drawer');
      // A rail rendered while the drawer was closed measured zero width.
      if (typeof setTimeout === 'function') setTimeout(updateAllNav, 350);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }
})();
